import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, from, Observable, of, throwError, TimeoutError } from "rxjs";
import { catchError,  filter, finalize, switchMap, take,  timeout } from "rxjs/operators";
import { HttpService } from "../_provider/http.service";
import { StorageService } from "../_provider/storage.service";
import { AuthService } from "../_provider/auth.service";
import { FeedbackService } from "../_provider/feedback.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor{

    private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null)
    private isRefreshingToken: boolean = false

    constructor( 
        private http: HttpService,
        private storageSrv: StorageService,
        private authSrv: AuthService,
        private feedback: FeedbackService
    ){}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if((req.url == `${this.http.getbaseUrl}user/login`) 
        || (req.url == this.http.getbaseUrl)
        || (req.url == this.http.getbaseUrl)
        || (req.url == `${this.http.getbaseUrl}user/licenses/devices`)
        || (req.url == `${this.http.getbaseUrl}user/passwordrecovery/update`)
        || (req.url.startsWith(`${this.http.getbaseUrl}support/customer/tickets/`))
        || (req.headers.get("disabled-no-response-handler") == "true")
        || (req.url == "https://www.afs-software.de/service/AFS_Ticketsystem/TicketsystemApp/V1/TicketAppPfade.txt"))
        return next.handle(req)
        
        return next.handle(req).pipe(
            catchError((err: any)=>{
                if(err instanceof TimeoutError || err.status == 0) return this.handleTimeout(req, next)
                if(!(err instanceof HttpErrorResponse)) return throwError(err)
                const httpError: HttpErrorResponse = (err as HttpErrorResponse)
                if(httpError.status == 403 || (httpError.status == 401 && req.url == `${this.http.getbaseUrl}user/login/renew`)) { 
                    this.authSrv.logout(false)
                    return throwError(err)  
                }
                if(httpError.status != 401 && httpError.status != 403) return throwError(err)
                if(httpError.status == 401) return this.handleUnautorized(req, next)
            })
        )
    }
 
    private handleUnautorized(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        if(!this.isRefreshingToken){ 
            this.tokenSubject.next(null)
            this.isRefreshingToken = true
            this.http.token = ""
            return this.http.getNewAccessToken().pipe(
                timeout(20000),
                switchMap((result: HttpResponse<any>)=>{
                    if(!result) return of(null)
                    const accessToken: string = result.body.data
                    this.http.token = accessToken
                    this.storageSrv.save('jwt-token', accessToken)
                    this.tokenSubject.next(accessToken)
                    return next.handle(this.addToken(req))
                }),
                finalize(()=> this.isRefreshingToken = false)
            )
        }else{
            return this.tokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addToken(req))
                })
            )
        }
    }

    private addToken(req: HttpRequest<any>){
        if(!this.http.token) return req
        return req.clone({
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Authorization": `Bearer ${this.http.token}`,
                "X-Version": this.http.serverVersion
            })
        })
    }


    
    private handleTimeout(req: HttpRequest<any>, next: HttpHandler): Observable<any>{

        //Wenn true ist es die erste Anfrage von die einen Timeout bekommt
        //sonst wird gewartet bis Server wieder erreichbar ist und request fortgeführt
        if(this.http.hasServerConnection.getValue() == true){
            this.feedback.hideLoading()
            this.feedback.showError("Der Server konnte leider nicht erreicht werden.")
            return this.http.setServerConnectionNotAvailable().pipe(
                switchMap(()=>{
                    return this.handleUnautorized(req, next)
                })
            )
        }else {
            return this.http.hasServerConnection.pipe(
                filter((val: boolean)=>val),
                switchMap(()=>{
                    return this.handleUnautorized(req, next)
                })
            )
        }
    }
}